export const categories = [
  {
    slug: 'tiyu',
    name: '体育赛事',
    description: '全球顶级体育赛事直播与资讯，涵盖足球、篮球、网球等多个项目',
    icon: 'ri-football-line',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20stadium%20scene%20with%20golden%20warm%20lighting%2C%20athletic%20energy%2C%20clean%20background%2C%20professional%20sports%20photography%20style%2C%20warm%20amber%20tones%2C%20minimalist%20composition&width=800&height=600&seq=cat-sports-01&orientation=landscape',
  },
  {
    slug: 'dianjing',
    name: '电子竞技',
    description: '热门电竞赛事实时追踪，专业赛事分析与精彩回放',
    icon: 'ri-gamepad-line',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20esports%20arena%20with%20warm%20golden%20ambient%20lighting%2C%20gaming%20setup%20with%20RGB%20accents%2C%20professional%20competitive%20gaming%20atmosphere%2C%20clean%20composition%2C%20warm%20tones&width=800&height=600&seq=cat-esports-01&orientation=landscape',
  },
  {
    slug: 'yule',
    name: '娱乐天地',
    description: '丰富多彩的娱乐内容，精彩节目、互动游戏、趣味活动应有尽有',
    icon: 'ri-movie-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20entertainment%20venue%20with%20warm%20golden%20lighting%2C%20luxurious%20interior%2C%20soft%20ambient%20atmosphere%2C%20sophisticated%20design%2C%20warm%20cream%20and%20gold%20tones%2C%20professional%20photography&width=800&height=600&seq=cat-entertain-01&orientation=landscape',
  },
  {
    slug: 'zhibo',
    name: '高清直播',
    description: '高清流畅的直播体验，多路信号源自由切换，精彩不容错过',
    icon: 'ri-live-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20broadcast%20studio%20with%20warm%20lighting%2C%20multiple%20screens%20displaying%20live%20content%2C%20modern%20technology%20setup%2C%20clean%20minimalist%20design%2C%20warm%20amber%20and%20cream%20tones&width=800&height=600&seq=cat-live-01&orientation=landscape',
  },
  {
    slug: 'youxi',
    name: '精选游戏',
    description: '海量精品游戏任您选择，经典与热门一应俱全，畅享游戏乐趣',
    icon: 'ri-game-line',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20board%20games%20and%20cards%20on%20a%20warm%20wooden%20table%2C%20elegant%20game%20room%20setting%2C%20soft%20golden%20lighting%2C%20sophisticated%20atmosphere%2C%20warm%20cream%20tones&width=800&height=600&seq=cat-games-01&orientation=landscape',
  },
  {
    slug: 'huodong',
    name: '优惠活动',
    description: '最新优惠活动一手掌握，超值福利不容错过，精彩好礼等您来拿',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20gift%20boxes%20with%20golden%20ribbons%20on%20a%20warm%20cream%20background%2C%20luxurious%20presentation%2C%20soft%20ambient%20lighting%2C%20premium%20lifestyle%20photography%2C%20warm%20gold%20tones&width=800&height=600&seq=cat-promo-01&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((cat) => cat.slug === slug) || categories[0];
};